<template>
    <div class="relative" :class="background()">
        <div :class="space()">
            <div v-if="title" class="">
                <h2 id="notes-title" class="text-lg font-medium text-gray-900 title" :class="spaceTitle()">{{title}}</h2>
            </div>
            <slot/>
        </div>
    </div>
</template>

<script>

export default {
    name: "_cell",
    props: {
        title: {
            type: String,
            default: '',
        },
        p: {
            type: Boolean,
            required: false,
        } ,
        b: {
            type: Boolean,
            default: false,
        }

    },
    methods: {
        background(){
            if(this.b){
                return 'bg-white rounded-md shadow-sm';
            }
        },
        space() {
            if(this.p){
                return 'p-4';
            }
        },
        spaceTitle() {
            if(this.p){
                return;
            }
            return 'p-4';
        },        
    }
}
</script>

<style scoped>
    .title {
        text-transform: capitalize;
    }
</style>